import { $admin } from "@/services/api";
import apiEndpoints from "@/constants/api-endpoints";
import { urlUserIdReplacer } from "@/utils/api.utils";

/**
 * Fetches user accounts (Membership) list
 * @param {String} userId Id of the user whose account member ship is to be fetched
 * @returns {Promise}
 */
export const getUserMembership = (userId, params = {}) => {
  return $admin.get(urlUserIdReplacer(apiEndpoints.userMembership, userId), {
    params,
  });
};

/**
 * Update user account membership
 * @param {Object} payload Payload of the user whose account access (membership) have to be updated
 * @returns {Promise}
 */
export const updateUserMembership = (id, payload) => {
  const endpoint = urlUserIdReplacer(apiEndpoints.userMembership, id);
  return $admin.put(endpoint, payload);
};

/**
 * Deletes user account membership
 * @param {String} id Id of the user whose account access are to be removed
 * @returns {Promise}
 */
export const removeUserMembership = (id, payload) => {
  const endpoint = urlUserIdReplacer(apiEndpoints.userMembership, id);
  return $admin.delete(endpoint, { data: payload });
};
